module.exports = __webpack_public_path__ + "img/configurazione_invio_mail_jobmule.fed17afc.png";